import React, { useEffect } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import * as ReactPixel from 'meta-pixel';
const PIXEL_ID = '1361874835769637';
function Root() {
  useEffect(() => {
    try {
      // @ts-ignore - support both default and named export shapes
      const pixel: any = (ReactPixel as any).default || ReactPixel;
      if (pixel && typeof pixel.init === 'function') {
        pixel.init(PIXEL_ID);
        if (typeof pixel.pageView === 'function') {
          pixel.pageView();
        } else if (typeof pixel.track === 'function') {
          pixel.track('PageView');
        }
      }
    } catch (e) {
      console.error('Meta Pixel init failed', e);
    }
  }, []);
  return <App data-id="element-171" />;
}
render(<Root data-id="element-172" />, document.getElementById('root'));